import Head from "next/head"
import React, { useEffect } from "react"

import useAuth from "@hooks/useAuth"
import { IDomain } from "@mono/essentials/types/UserTypes"

import ButtonPreview from "./ButtonPreview"
import CalendarPreview from "./CalendarPreview"
import CustomWidgetPreview, { Footer, Header } from "./CustomWidgetPreview"
import DefaultWidgetPreview from "./DefaultWidgetPreview"

interface PreviewProps {
  data: any
  type: string
  isIntegratedPage?: boolean
  domainBasicDetails?: IDomain
  nextStep?: string
}

const Preview = ({
  data,
  type,
  isIntegratedPage = false,
  domainBasicDetails,
  nextStep,
}: PreviewProps) => {
  const { domainDetails } = useAuth()
  const widgtetOnIframe = window === window.parent

  return (
    <>
      <div className={"widget-theme-wrapper"}>
        <Head>
          {process.env.NEXT_PUBLIC_PRODUCTION === "true" && (
            <>
              <script
                src={`https://www.googletagmanager.com/gtag/js?id=${domainBasicDetails?.ga_tracking?.id}`}
              />
              <script id={"google-analytics"}>
                {`
                window.dataLayer = window.dataLayer || [];
                function gtag(){dataLayer.push(arguments);}
                gtag('js', new Date());
                gtag('config', '${domainBasicDetails?.ga_tracking?.id}');
              `}
              </script>
            </>
          )}
        </Head>
        {type === "calendar" && (
          <>
            {widgtetOnIframe && isIntegratedPage ? (
              <div className={"lg:py-8 md:py-4 py-2 overflow-auto"}>
                <div className={"max-w-screen-lg mx-auto"}>
                  <Header
                    domainDetails={isIntegratedPage ? domainBasicDetails : domainDetails}
                    heading={"Availability for booking"}
                    parentClassName={""}
                    isIntegratedPage={isIntegratedPage}
                  />
                  <CalendarPreview
                    data={data}
                    showBigCalendar={
                      data.calendar_for === "all_products" &&
                      data.show_product_in_calendar === "directly_show_in_calendar"
                    }
                    selectedProduct={data.product}
                    productView={data.show_product_detail_page}
                    isIntegratedPage={isIntegratedPage}
                    domainDetails={isIntegratedPage ? domainBasicDetails : domainDetails}
                    nextStep={nextStep}
                    hideCustomerDetails
                  />
                  <Footer domainDetails={isIntegratedPage ? domainBasicDetails : domainDetails} />
                </div>
              </div>
            ) : (
              <CalendarPreview
                data={data}
                showBigCalendar={
                  data.calendar_for === "all_products" &&
                  data.show_product_in_calendar === "directly_show_in_calendar"
                }
                selectedProduct={data.product}
                productView={data.show_product_detail_page}
                isIntegratedPage={isIntegratedPage}
                domainDetails={isIntegratedPage ? domainBasicDetails : domainDetails}
                nextStep={nextStep}
              />
            )}
          </>
        )}

        {type === "button" && (
          <ButtonPreview
            data={data}
            isIntegratedPage={isIntegratedPage}
            domainDetails={isIntegratedPage ? domainBasicDetails : domainDetails}
            nextStep={nextStep}
          />
        )}

        {type === "custom_widget" && (
          <CustomWidgetPreview
            data={data}
            isIntegratedPage={isIntegratedPage}
            domainDetails={isIntegratedPage ? domainBasicDetails : domainDetails}
            nextStep={nextStep}
          />
        )}

        {!type && (
          <DefaultWidgetPreview
            isIntegratedPage={isIntegratedPage}
            domainDetails={isIntegratedPage ? domainBasicDetails : domainDetails}
            nextStep={nextStep}
          />
        )}
      </div>
    </>
  )
}

export default Preview
